var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "child-Page" },
    [
      _c("childNav", {
        attrs: { routerName: _vm.$t("elevator.title"), backFlag: true },
      }),
      _c("div", { staticClass: "modules-container" }, [
        _c("div", { staticClass: "module" }, [
          _vm.uploadStatus === "waiting"
            ? _c(
                "div",
                { staticClass: "module-header" },
                [
                  _c(
                    "Upload",
                    {
                      attrs: {
                        type: "drag",
                        "before-upload": _vm.handleSuccess,
                        action: "/",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "drag-box" },
                        [
                          _c("h2", [_vm._v(_vm._s(_vm.$t("elevator.label")))]),
                          _c("Icon", {
                            attrs: { size: "148", type: "md-cloud-upload" },
                          }),
                          _c("h3", [
                            _vm._v(_vm._s(_vm.$t("elevator.uploadTip"))),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm.uploadStatus === "success"
            ? _c(
                "div",
                { staticClass: "module-header" },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("elevator.label")))]),
                  _c("Icon", {
                    attrs: { size: "148", type: "md-cloud-upload" },
                  }),
                  _c("h3", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("elevator.fileLabel") + _vm.outputJsonName
                        ) +
                        " "
                    ),
                  ]),
                  _c("h3", [_vm._v(_vm._s(_vm.$t("elevator.tip")))]),
                ],
                1
              )
            : _vm.uploadStatus === "error"
            ? _c(
                "div",
                { staticClass: "module-header" },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("elevator.label")))]),
                  _c("Icon", {
                    attrs: { size: "148", type: "md-cloud-upload" },
                  }),
                  _c(
                    "h3",
                    { staticClass: "error" },
                    [
                      _c("Icon", { attrs: { type: "md-alert" } }),
                      _vm._v(
                        _vm._s(_vm.$t("elevator.error" + _vm.errorType)) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.uploadStatus === "waiting" || _vm.uploadStatus === "error"
            ? _c(
                "div",
                { staticClass: "module-foot" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "w-50 file",
                      attrs: {
                        type: "primary",
                        size: "large",
                        shape: "circle",
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("elevator.upload")) + " "),
                      _c("input", {
                        ref: "fileInput",
                        attrs: { type: "file" },
                        on: {
                          change: function ($event) {
                            return _vm.handleBtnUpload($event)
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "module-foot" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "w-50",
                      attrs: {
                        type: "primary",
                        size: "large",
                        shape: "circle",
                      },
                      on: { click: _vm.outputJson },
                    },
                    [_vm._v(_vm._s(_vm.$t("elevator.downloadfile")))]
                  ),
                ],
                1
              ),
        ]),
        _c("div", { staticClass: "module" }, [
          _c("div", { staticClass: "module-header" }, [
            _c(
              "div",
              { staticClass: "drag-box" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.$t("elevator.download")))]),
                _c("Icon", {
                  attrs: { size: "148", type: "md-cloud-download" },
                  on: { click: _vm.downloadTemplate },
                }),
                _c("a", { on: { click: _vm.downloadTemplate } }, [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("elevator.generate")))]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "module-foot" },
            [
              _c(
                "Button",
                {
                  staticClass: "w-50",
                  attrs: { type: "primary", size: "large", shape: "circle" },
                  on: { click: _vm.downloadTemplate },
                },
                [_vm._v(" " + _vm._s(_vm.$t("elevator.downloadTip")) + " ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }